/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_Error_TrackingInputs */

const en_cookie_consent_error_tracking = /** @type {(inputs: Cookie_Consent_Error_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error Tracking`)
};

const de_cookie_consent_error_tracking = /** @type {(inputs: Cookie_Consent_Error_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlererfassung`)
};

const fr_cookie_consent_error_tracking = /** @type {(inputs: Cookie_Consent_Error_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi des erreurs`)
};

const es_cookie_consent_error_tracking = /** @type {(inputs: Cookie_Consent_Error_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento de errores`)
};

const it_cookie_consent_error_tracking = /** @type {(inputs: Cookie_Consent_Error_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracciamento errori`)
};

const nl_cookie_consent_error_tracking = /** @type {(inputs: Cookie_Consent_Error_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foutopsporing`)
};

const pl_cookie_consent_error_tracking = /** @type {(inputs: Cookie_Consent_Error_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sledzenie bledow`)
};

const fi_cookie_consent_error_tracking = /** @type {(inputs: Cookie_Consent_Error_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virheseuranta`)
};

const da_cookie_consent_error_tracking = /** @type {(inputs: Cookie_Consent_Error_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejlsporing`)
};

const sv_cookie_consent_error_tracking = /** @type {(inputs: Cookie_Consent_Error_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felspaning`)
};

/**
* | output |
* | --- |
* | "Error Tracking" |
*
* @param {Cookie_Consent_Error_TrackingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_error_tracking = /** @type {((inputs?: Cookie_Consent_Error_TrackingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_Error_TrackingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_error_tracking(inputs)
	if (locale === "fr") return fr_cookie_consent_error_tracking(inputs)
	if (locale === "es") return es_cookie_consent_error_tracking(inputs)
	if (locale === "it") return it_cookie_consent_error_tracking(inputs)
	if (locale === "nl") return nl_cookie_consent_error_tracking(inputs)
	if (locale === "pl") return pl_cookie_consent_error_tracking(inputs)
	if (locale === "fi") return fi_cookie_consent_error_tracking(inputs)
	if (locale === "da") return da_cookie_consent_error_tracking(inputs)
	if (locale === "sv") return sv_cookie_consent_error_tracking(inputs)
	return en_cookie_consent_error_tracking(inputs)
});